import api from './api';

const notificationService = {
  getNotifications: (cursor, limit = 20, category) => {
    const params = { limit };
    if (cursor) params.cursor = cursor;
    if (category) params.category = category;
    return api.get('/notifications', { params, baseURL: '/api' });
  },

  getUnreadCount: () =>
    api.get('/notifications/unread-count', { baseURL: '/api' }),

  markRead: (notificationId) =>
    api.put(`/notifications/${notificationId}/read`, {}, { baseURL: '/api' }),

  markAllRead: () =>
    api.put('/notifications/read-all', {}, { baseURL: '/api' }),

  deleteNotification: (notificationId) =>
    api.delete(`/notifications/${notificationId}`, { baseURL: '/api' }),

  getPreferences: () =>
    api.get('/notifications/preferences', { baseURL: '/api' }),

  updatePreferences: (prefs) =>
    api.put('/notifications/preferences', prefs, { baseURL: '/api' }),

  registerDeviceToken: (token, platform = 'web') =>
    api.post('/notifications/device-token', { token, platform }, { baseURL: '/api' }),

  unregisterDeviceToken: (token) =>
    api.delete('/notifications/device-token', { data: { token }, baseURL: '/api' }),
};

export default notificationService;
